import { useMemo } from 'react'
import { connect } from 'react-redux';
import {
  Name,
  LockedLabel,
  UnlockedLabel,
  Flex,
  CategoryHeaderRow
} from './styles'
import Icon from '../../../../../../components/Icon';
import padlockLockIcon from '../../../../../../assets/icons/padlock-lock.svg'
import ReorderButton from '../ReorderButton'
import EditCategory from '../EditCategoryButton'
import ViewMoreButton from "../ViewMoreButton";
import { exactHumanUnlockTime } from '../../../../../../helpers/humanUnlockTime';
import UnlockedCategoryMedal from '../../../../../components/UnlockedCategoryMedal';

const Component = ({
  category,
  group,
  setCategoryToEdit,
  setEditCategorySidebarVisible,
  setIdCategoryToOrder,
  setReorderContentSidebarVisible
}) => {
  const humanReadableTime = useMemo(() => {
    return exactHumanUnlockTime(category)
  }, [category]);

  return (
    <Flex style={{ flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
      <CategoryHeaderRow>
        <Flex>
          {category?.locked_ordinal && (
            <UnlockedCategoryMedal category={category} width="32px" height="auto" />
          )}

          <Name>{category?.name}</Name>
        </Flex>

        {category?.id !== 'without_category' && (
          <Flex>
            <EditCategory
              onClick={() => {
                setCategoryToEdit(category)
                setEditCategorySidebarVisible(true)
              }}
            />

            {category?.last_posts && category?.last_posts.length > 0 && (
              <>
                <ReorderButton
                  onClick={() => {
                    setIdCategoryToOrder(category?.id)
                    setReorderContentSidebarVisible(true)
                  }}
                />

                <ViewMoreButton category={category} />
              </>
            )}
          </Flex>
        )}
      </CategoryHeaderRow>

      {humanReadableTime ? (
        <LockedLabel>
          <Icon icon={padlockLockIcon} size="20px" color="#93410F" />
          {humanReadableTime}
        </LockedLabel>
      ) : (
        <UnlockedLabel>Siempre disponible</UnlockedLabel>
      )}
    </Flex>
  )
}

const state = ({ groupStore }) => {
  const { data: group, states: groupStates } = groupStore.group;

  return {
    group,
    groupStates
  };
};

export default connect(state)(Component);